const strengths = [
  {
    title: '地域密着対応',
    desc: '神奈川県大和市を拠点に、地域の企業様へ迅速にお伺いします。電話一本で相談できる身近な存在です。',
  },
  {
    title: '中小企業専門',
    desc: '「IT担当がいない」企業様を中心に、分かりやすい言葉でご説明します。難しい知識は不要です。',
  },
  {
    title: 'ITをワンストップ支援',
    desc: 'セキュリティ・ネットワーク・機器調達・集客支援まで、ITに関することはまとめてお任せいただけます。',
  },
  {
    title: '導入後もしっかりサポート',
    desc: '機器の設置・設定から、導入後の運用サポートまで継続してお付き合いします。安心の長期対応体制です。',
  },
];

const processSteps = [
  { num: '01', title: '無料相談', desc: 'まずはお電話またはフォームよりお気軽にご連絡ください。' },
  { num: '02', title: '現状ヒアリング', desc: '現在のネットワーク環境やお悩みを丁寧にお聞きします。' },
  { num: '03', title: '最適提案', desc: '企業様の規模・予算に合った最適なプランをご提案します。' },
  { num: '04', title: '導入', desc: '機器の設置・設定をすべて対応。お客様の手間は最小限です。' },
  { num: '05', title: '運用サポート', desc: '導入後も継続してサポート。困ったときはいつでも相談できます。' },
];

const CompanySection: React.FC = () => (
  <>
    {/* Company intro */}
    <section id="company" className="py-24 bg-slate-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          <div>
            <span className="inline-block text-sky-600 text-sm font-bold tracking-widest uppercase mb-4">
              私たちについて
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 leading-tight mb-6">
              神奈川県大和市を拠点に<br />
              中小企業をサポート
            </h2>
            <p className="text-slate-500 text-base leading-relaxed mb-8">
              地域のみなさまの「困った」を解決するために、大和市を拠点として神奈川県全域の中小企業のIT課題に向き合ってきました。
              セキュリティから集客まで、ITに関することはワンストップでお任せいただけます。
            </p>

            {/* Company info card */}
            <div className="bg-white rounded-2xl border border-sky-100 p-6 mb-6">
              <p className="text-sky-600 text-xs font-bold tracking-widest uppercase mb-4">会社情報</p>
              <div className="flex flex-col gap-3.5">
                <div>
                  <p className="text-slate-800 font-bold text-sm">株式会社湘南ビジネスサポート</p>
                  <p className="text-slate-500 text-xs mt-0.5">代表取締役　森　尚樹</p>
                </div>
                <p className="text-slate-600 text-sm">神奈川県大和市南林間2丁目18-4</p>
                <a href="tel:09027740856" className="text-slate-600 text-sm hover:text-sky-600 transition-colors cursor-pointer">
                  090-2774-0856
                </a>
                <a href="mailto:info.shonanbiz.spt@gmail.com" className="text-slate-600 text-sm hover:text-sky-600 transition-colors cursor-pointer break-all">
                  info.shonanbiz.spt@gmail.com
                </a>
                <div className="border-t border-sky-50 pt-3 mt-1">
                  <p className="text-sky-600 text-xs font-bold tracking-widest uppercase mb-2">許認可・届出</p>
                  <div className="flex flex-col gap-1.5">
                    <p className="text-slate-600 text-xs">
                      <span className="font-semibold text-slate-700">古物商許可番号：</span>第452750021820号
                    </p>
                    <p className="text-slate-600 text-xs">
                      <span className="font-semibold text-slate-700">総務省届出番号：</span>C2130299
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              {[
                '神奈川県大和市を中心に近隣エリアへ即日対応',
                'IT担当者がいない企業様に特化したサポート',
                '不要なPCの引き取りサービスも対応',
              ].map((item) => (
                <p key={item} className="text-slate-600 text-sm">・{item}</p>
              ))}
            </div>
          </div>

          {/* Google Maps + photo */}
          <div className="flex flex-col gap-4">
            <div className="rounded-2xl overflow-hidden h-64 bg-slate-100 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/50d82ed5e67db213de3cd7b55d8920db/7c6a3ed7e0c4b6c2e2894c907f853820.png"
                alt="会社イメージ"
                className="w-full h-full object-contain"
              />
            </div>
            {/* Google Maps embed */}
            <div className="rounded-2xl overflow-hidden h-56 border border-slate-100">
              <iframe
                title="株式会社湘南ビジネスサポート 地図"
                src="https://maps.google.com/maps?q=神奈川県大和市南林間2丁目18-4&output=embed&hl=ja&z=16"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="bg-sky-50 rounded-xl px-4 py-3">
              <p className="text-slate-800 text-xs font-bold">神奈川県大和市南林間2丁目18-4</p>
              <p className="text-slate-500 text-xs mt-0.5">小田急江ノ島線「南林間駅」より徒歩圏内</p>
            </div>
          </div>
        </div>

        {/* Strength cards */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {strengths.map((s) => (
            <div key={s.title} className="bg-white rounded-xl p-6 flex flex-col gap-2 border border-slate-100">
              <h3 className="font-bold text-slate-800 text-sm">{s.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Process */}
    <section id="process" className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block text-sky-600 text-sm font-bold tracking-widest uppercase mb-4">
            導入の流れ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 leading-tight">
            シンプルな5ステップで導入完了
          </h2>
          <p className="mt-4 text-slate-500 text-base max-w-xl mx-auto leading-relaxed">
            専門知識は不要です。最初のご相談から導入・運用まで、すべてお任せいただけます。
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-8 left-0 right-0 h-0.5 bg-sky-100 z-0 mx-20" />
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6 relative z-10">
            {processSteps.map((step, i) => (
              <div key={step.num} className="flex flex-col items-center text-center">
                <div className={`w-16 h-16 flex items-center justify-center rounded-full font-bold text-lg mb-4 ${
                  i === 0 ? 'bg-sky-600 text-white' : 'bg-white border-2 border-sky-200 text-sky-600'
                }`}>
                  {step.num}
                </div>
                <h3 className="font-bold text-slate-800 text-sm mb-2">{step.title}</h3>
                <p className="text-slate-500 text-xs leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  </>
);

export default CompanySection;
